import { useEffect, useRef } from "react";

const MAX_RETRIES = 5;

interface IUseSmarticoProps {
  onPropsChange?: (props?: any) => void;
}

const useSmartico = (props?: IUseSmarticoProps) => {
  const isAlreadyStarted = useRef(false);
  const smarticoScriptTag = document.getElementById("smartico-script");

  useEffect(() => {
    if (isAlreadyStarted.current) {
      return;
    }
    const smarticoScriptTag = document.getElementById("smartico-script");
    if (!smarticoScriptTag) {
      (function (d, r, b?: unknown, h?: HTMLHeadElement, s?: HTMLScriptElement) {
        h = d.getElementsByTagName("head")[0];
        s = d.createElement("script");
        s.onload = function () {
          // Ensure hash value without angular js hashbang
          if (window.location.hash.indexOf("_smartico_dp") !== -1) {
            var newHashValue = (window.location.hash = window.location.hash.replace("#!", ""));
            if (history.pushState) {
              history.pushState(null, null, newHashValue);
            } else {
              location.hash = newHashValue;
            }
          }

          onInit(1);
          window._smartico_allow_localhost = true;
          window._smartico_language = "en";
        };
        s.id = "smartico-script";
        s.src = r;
        h.appendChild(s);
        isAlreadyStarted.current = true;
      })(document, "https://libs.smartico.ai/smartico.js");
    }
  }, []);

  const onInit = (retries = 0) => {
    if (!window?._smartico?.init) {
      setTimeout(() => onInit(retries + 1), 1000);
    } else {
      window._smartico.init("6de24f66-dd01-48cf-9142-66184a5e984c-4", {
        brand_key: "1c85e24b",
      });
    }
  };

  useEffect(() => {
    if (smarticoScriptTag) {
      return;
    }
    onInit();
  }, []);

  const getApi = (): Promise<ReturnType<typeof window._smartico.api | typeof window._smartico.vapi>> => {
    return new Promise(resolve => {
      const waitForApi = () => {
        const smarticoApi = !!window._smartico_user_id ? window?._smartico?.api : window?._smartico?.vapi("EN");
        if (smarticoApi) {
          resolve(smarticoApi);
        } else {
          setTimeout(waitForApi, 1000);
        }
      };
      waitForApi();
    });
  };

  return getApi;
};

export default useSmartico;
